import img01 from './img01.jpg';
import img02 from './img02.jpg';
import img03 from './img03.jpg';
import img04 from './img04.jpg';
import img05 from './img05.jpg';
import img06 from './img06.jpg';
import img07 from './img07.jpg';
import img08 from './img08.jpg';

export const IMAGES = [
    {
        src: img01,
        thumbnail: img01,
        thumbnailWidth: 500,
        thumbnailHeight: 350,
        caption: "Independence Celebration"
    },
    {
        src: img02,
        thumbnail: img02,
        thumbnailWidth: 500,
        thumbnailHeight: 350,
        caption: "Republic Day Celebration"
    },
    {
        src: img03,
        thumbnail: img03,
        thumbnailWidth: 500,
        thumbnailHeight: 350,
        caption: "Women Empowerment"
    },
    {
        src: img04,
        thumbnail: img04,
        thumbnailWidth: 500,
        thumbnailHeight: 350,
        caption: "Valmiki Jayanti Celebration"
    },
    {
        src: img05,
        thumbnail: img05,
        thumbnailWidth: 500,
        thumbnailHeight: 350,
        caption: "Save Environment Campaign"
    },
    {
        src: img06,
        thumbnail: img06,
        thumbnailWidth: 500,
        thumbnailHeight: 350,
        caption: "Tree Plantation"
    },
    {
        src: img07,
        thumbnail: img07,
        thumbnailWidth: 500,
        thumbnailHeight: 350,
        caption: "Tree Plantation"
    },
    {
        src: img08,
        thumbnail: img08,
        thumbnailWidth: 500,
        thumbnailHeight: 350,
        caption: "Sarak Suraksha Abhiyan"
    },
]